"use client";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
export default function Parktimings() {
    const [image1, setImage1] = useState("");
    const [image2, setImage2] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const res = await fetch("/api/tickettimebanners");
                if (!res.ok) return;

                const result = await res.json();

                if (result) {
                    setTitle(result.title || "");
                    setDescription(result.description || "");
                    setImage1(result.image1 || "");
                    setImage2(result.image2 || "");
                }
            } catch (error) {
                console.log(error);
            }
            finally {
                setLoading(false);
            }
        };

        fetchImages();
    }, []);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh', width: '100%' }}>
                <div className="spinner-border" role="status" style={{ color: 'var(--theme-color, #F55B1F)', width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <div
                className="breadcrumb-wrapper bg-cover"
                style={{ backgroundImage: 'url("/assets/img/breadcrumb-bg.jpg")' }}
            >
                <div className="shape-image float-bob-y">
                </div>
                <div className="container">
                    <div className="breadcrumb-wrapper-items">
                        <div className="page-heading">
                            <div className="breadcrumb-sub-title">
                                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                    Timings & Ticket Pricings
                                </h1>
                            </div>
                            <ul
                                className="breadcrumb-items wow fadeInUp"
                                data-wow-delay=".5s"
                            >
                                <li>
                                    <Link href={`/`}> Home </Link>
                                </li>
                                <li>
                                    <i className="fa-sharp fa-solid fa-slash-forward" />
                                </li>
                                <li> Timings & Ticket Pricings</li>
                            </ul>
                        </div>
                        <div className="breadcrumb-image">
                            <div className="bar-shape">
                                <Image
                                    src="/assets/img/breadcrumb-bar.png"
                                    width={631}
                                    height={604}
                                    alt="img"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section
                id="about"
                className="about-section fix section-padding scrollSpySection pb-5"
            >
                <div className="container">
                    <div className="about-wrapper">
                        <div className="row justify-content-center pb-5">
                            <div className="col-lg-9 text-center">
                                <h2 className="wow fadeInUp pb-3" data-wow-delay=".3s">
                                    {title}
                                </h2>
                                <p>{description}</p>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <img
                                    src={image1 || "/assets/img/parktimings.png"}
                                    alt="Park Timings"
                                    width={600}
                                    height={343}
                                />
                            </div>
                            <div className="col-lg-6">
                                <Link href="/ticket">
                                <img
                                
                                    src={image2 || "/assets/img/entryticket.png"}
                                    alt="Entry Ticket"
                                    width={600}
                                    height={343}
                                />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
